import EntityIcon from '../../../../components/EntityIcon/EntityIcon';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import React from 'react';
import {Box, PreviewContainer, ResultSubject, Text} from '../../../../styled';
import OfficeIcon from './OfficeIcon';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import {getMeetingLocation} from './CalendarSnippet';


const CalendarPreview = ({ item }: any) => {
  const location = getMeetingLocation(item, true);

  return (
    <Box display="flex" flexDirection="column" overflow="hidden" width="100%">
      <Box display="flex" alignItems="center">
        <Box mr={20}>
          <EntityIcon entityName={item.pl} />
        </Box>
        <Box>
          <Box display="flex" alignItems="center">
            <OfficeIcon type="calendar" noMargin />
            <ResultSubject paddingLeft="5px" mb={0}>
              <HighlightMarker>{item.title}</HighlightMarker>
            </ResultSubject>
            <div style={{ width: 30, display: 'inline-block' }}>
              <OfficeIcon type="outlook" />
            </div>
          </Box>
          <Text mb={0}>
            {item.dateString}
          </Text>
        </Box>
      </Box>
      <PreviewContainer
        display="flex"
        flexDirection="column"
        ml={[0, 60]}
        flex="1"
      >
        <Text>
          Organizer: {item.displayOrganizer}
        </Text>
        <Text>
          Attendees: {item.meetingAttendees.join(', ') || 'None'}
        </Text>
        <Text>
          Location: {location}
        </Text>
        <Text>
          {item.resultMessage}
        </Text>
      </PreviewContainer>
      <FileAttachments files={item.att} />
    </Box>
  )
}

export default CalendarPreview;